module.exports = __webpack_public_path__ + "static/media/Tarots_01_All-17.c5aca620.svg";